/**
* @file UserCreateEditForm.js
 
* @author - Team D (Meeramol Mathew),TeamE(Keerthana,Karpakam)    
* @sprint - B2W-Sprint-5
* @description -
* This component is a modal form used to create or update an item.
* It includes fields for selecting an activity, picking a date.
*/

import React, { useState, useEffect } from "react";
import { Modal, Form, Select, DatePicker } from "antd";
import moment from "moment";
import axios from "axios";
import store from "../../redux/store";
import UserAccountActivityLabels from "../../pages/UserAccountActivityLabels.json";



const UserCreateEditForm = ({ visible, setVisible, onCreate, onUpdate, selectedRecord }) => {
  const [form] = Form.useForm();
  const [isUpdated, setIsUpdated] = useState(false);
  const [activityOptions, setActivityOptions] = useState([]);


  // Effect to handle form data population on record selection
  // useEffect(() => {
  //   if (selectedRecord) {
  //     form.setFieldsValue({
  //       ...selectedRecord,
  //       date: moment(selectedRecord.date, 'DD-MM-YYYY'), // Convert the string to moment for DatePicker
  //     });
  //     setIsUpdated(false); // Reset update state on edit
  //   } else {
  //     form.resetFields(); // Reset form fields when there's no selected record
  //   }
  // }, [form, selectedRecord]);

  useEffect(() => {
    if (visible) {
      fetchActivitiesByType("ACCOUNT_ACTIVITY")
        .then((data) => {
          console.log("Fetched activities data:", data);

          // Mapping the fetched data to dropdown options
          const options = data.map((activity) => ({
            value: activity.id,          // Use `id` from the fetched activity
            label: activity.activityName // Use `activityName` as the label
          }));

          // Set the options state to update the dropdown
          setActivityOptions(options);
        })
        .catch((error) => {
          console.error("Error fetching activities:", error);
        });
    }
  }, [visible]); // This will trigger when the modal becomes visible


  const fetchActivitiesByType = async (type) => {
    const token = store.getState().auth.token;  // Retrieve token from the store

    if (!token) {
      throw new Error("No token found. User not authenticated.");
    }

    try {
      const response = await axios.get(`http://localhost:8080/userAccountActivities/getActivitiesByType/${type}`, {
        headers: {
          'Authorization': `Bearer ${token}`  // Pass the token in the Authorization header
        }
      });

      return response.data;
    } catch (error) {
      console.error("Error fetching activities:", error);
      throw error;
    }
  };


  /**
 * Handles modal close action.
 * Resets form if no record is selected and closes the modal.
 */
  const handleCancel = () => {
    if (!selectedRecord) {
      form.resetFields(); // Clear all form fields
    }
    setVisible(false); // Close modal
  };

  /**
   * Handles form field changes.
   * Enables the update button when a field is modified.
   */
  const handleValuesChange = () => {
    // Check if any field value is changed, if so, enable the Update button
    setIsUpdated(true);
  };
  const handleCreate = () => {
    form.validateFields()
      .then((values) => {

        // Find the selected activity label based on the selected value
        const selectedOption = activityOptions.find(option => option.value === values.activity);

        // Create the jsonData object with activity, date, and userId
        const jsonData = {
          ...values,
          activityId: selectedOption ? selectedOption.value : '', // Include the label for activity
          activityName: selectedOption ? selectedOption.label : '',
          //activityDate: values.date.format('DD-MM-YYYY'), // Format the date to DD-MM-YYYY

          key: selectedRecord ? selectedRecord.key : Date.now() // Use Date.now() for new records
        };
       
        // if (selectedRecord) {
        //   onUpdate(jsonData, selectedRecord);  // Update existing record and pass values to parent
        // }
        // else {
          onCreate(jsonData);  // Create new record and pass values to parent
          form.resetFields();  // Reset form fields after creating a new record
       // }
        setIsUpdated(false); // Reset the updated state after submitting
        // Close modal after submission
        setVisible(false);
        console.log("calling onCreate Fn:");
      })
      .catch((info) => {
        console.log("Validation Failed:", info);
      });
  };

  return (

    <Modal
      open={visible}

      title={

        <div className=" pt-2 pb-2 px-4 pl-0 rounded-lg sticky top-0 bg-white z-10">
          {/* <span className="inline-block text-primary p-2 pl-0 text-xl"> */}
          <span className="inline-block p-2 pl-0 text-xl" style={{ color: 'rgb(44, 87, 120)' }}> 
            {selectedRecord ? UserAccountActivityLabels.Edit_Activity : UserAccountActivityLabels.Add_New_Activity}
          </span>
        </div>
      }


      okText={selectedRecord ? UserAccountActivityLabels.Button_Update : UserAccountActivityLabels.Button_Submit}
      onCancel={handleCancel}  // Use handleCancel to reset fields and close modal

      onOk={handleCreate}  // Submit form on OK
      okButtonProps={{
        className: "text-white border p-4 bg-[var(--color-primary)]",
        style: !isUpdated ? {
                  color: 'white', 
                  cursor: 'not-allowed', // Change the cursor to indicate the button is disabled
                  opacity: 0.6 // Optional: Make the button appear slightly faded
                } : {},
        disabled: !isUpdated, // Disable the button if nothing has been updated
      }}
      cancelButtonProps={{
        className: "text-white border p-4 bg-[var(--color-primary)]"

      }}
      maskClosable={false} // Prevents closing on outside click
    >

      <div className="modal-content-wrapper" >
        <Form form={form} layout="vertical"
          onValuesChange={handleValuesChange}
        >

          {/* Item Selection Field (Dropdown for Activity) */}
          <Form.Item
            name="activity"
            label={<span style={{ color: 'rgb(44, 87, 120)', fontWeight: 'bold' }}>{UserAccountActivityLabels.ActivityTitile}</span>}
            rules={[{ required: true, message: UserAccountActivityLabels.Activity_Select_message }]}
          >
            <Select placeholder="Select an activity">
              {activityOptions.map(option => (
                <Select.Option key={option.value} value={option.value}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          {/* DatePicker Field */}
          {/* <Form.Item
            label={<span style={{ color: 'rgb(44, 87, 120)', fontWeight: 'bold' }}>{UserAccountActivityLabels.ActivityDate}</span>}
            name="date"
            rules={[{ required: true, message: UserAccountActivityLabels.Date_Select_message }]}
          >
            <DatePicker
              className="w-full"
              format="DD-MM-YYYY"
              disabledDate={(current) => current && current > new Date()}
              inputReadOnly={true}  // This disables manual editing
            />
          </Form.Item> */}


        </Form>
      </div>


    </Modal>
  );

};
export default UserCreateEditForm;
